import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerMessage } from '../_models/server.message';
import { environment } from '../../../../environments/environment';

import { Observable, throwError, from } from 'rxjs';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { AlertService } from './alert.service';
import { encrypt, decrypt } from './security.service';

import jsencrypt from 'jsencrypt';
import { StorageService } from './storage/storage.service';
import { LoaderCustomService } from '../loaderCustom/loaderCustom.service';
@Injectable({
  providedIn: 'root'
})
export class RestService {

  constructor(private http: HttpClient, alertService: AlertService, private storageService: StorageService,
    private loaderCustomService: LoaderCustomService,) {
  }
  private BASE_URL: string = environment.apiurl;
  private BASE_URL_BACK = environment.apiurlBack;
  private _httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  baseURLKey(serviceName: string, methodName: string,): string {
    return serviceName + "/" + methodName;
  }

  baseURLGetwithParam(serviceName: string, methodName: string, param: any): string {
    if (param) {
      var parameter = "";
      let i = 0;
      for (const key in param) {
        if (i == 0) {
          parameter += "?" + key + "=" + param[key];
        } else {
          parameter += "&" + key + "=" + param[key];
        }
        i++;
      }
    }
    var url = serviceName + "/" + methodName + parameter;

    return url;
  }
  baseURLsyndifi(methodName: string): string {
    return this.BASE_URL + "" + methodName;
  }

  get(endPoint: string, data: any = null) {
    return this.request('get', endPoint, data);
  }

  delete(endPoint: string) {
    return this.request('delete', endPoint, null);
  }

  post(reqData: any) {
    let endPoint = Object.keys(reqData)[0];
    return this.request('post', endPoint, reqData);
  }

  put(reqData: any) {
    let endPoint = Object.keys(reqData)[0];
    return this.request('put', endPoint, reqData);
  }

  fileUpload(reqData: any) {
    let endPoint = 'UploadFile';
    return this.http.post(`${this.BASE_URL_BACK}${endPoint}`, reqData)
      .pipe(map((res: any) => res[endPoint]))
      .pipe(catchError(this.handleError));
  }
  commonFileUpload(reqData: any, endPoint: string) {
    return this.http.post(`${this.BASE_URL_BACK}${endPoint}`, reqData)
      .pipe(map((res: any) => res[endPoint]))
      .pipe(catchError(this.handleError));
  }

  // fileUpload(reqData: any) {
  //   let endPoint = 'UploadFile';

  //   let ApiBaseUrl = this.BASE_URL;
  //   let ApiBaseUrlBack = this.BASE_URL_BACK;

  //   let finalReq = {
  //     "params": reqData,
  //     "method": 'post',
  //     "url": `${ApiBaseUrlBack}${endPoint}`,
  //     "loginSessionKey": "1a0308f58bbc00c859bb162522805dd7"
  //   }

  //   reqData.append("paramsObj", JSON.stringify(finalReq));

  //   console.log(reqData)

  //   return this.http.post(`${ApiBaseUrl}`, reqData)
  //     .pipe(map((res: any) => res[endPoint]))
  //     .pipe(catchError(this.handleError));
  // }
  // commonFileUpload(reqData: any, endPoint: string) {

  //   let ApiBaseUrl = this.BASE_URL;
  //   let ApiBaseUrlBack = this.BASE_URL_BACK;

  //   let finalReq = {
  //     "params": reqData,
  //     "method": 'post',
  //     "url": `${ApiBaseUrlBack}${endPoint}`,
  //     "loginSessionKey": "1a0308f58bbc00c859bb162522805dd7"
  //   }

  //   return this.http.post(`${ApiBaseUrl}`, finalReq)
  //     .pipe(map((res: any) => res[endPoint]))
  //     .pipe(catchError(this.handleError));
  // }
  private request(method: string, endPoint: string, data: any): Observable<any> {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      this._httpOptions.headers = this._httpOptions.headers.set('x-access-token', accessToken);
    }

    let ApiBaseUrl = this.BASE_URL;
    let ApiBaseUrlBack = this.BASE_URL_BACK;
    let logginSessionKey = localStorage.getItem('accesToken') ? localStorage.getItem('accesToken') : '';

    this.loaderCustomService.show();

    if (environment.localMode) {
      const directOptions: any = {
        headers: this._httpOptions.headers,
        body: JSON.stringify(data),
      };
      return this.http.request(method, `${ApiBaseUrlBack}${endPoint}`, directOptions)
        .pipe(
          map((res: any) => {
            this.loaderCustomService.hide();
            return res?.[endPoint] !== undefined ? res[endPoint] : res;
          }),
          catchError(this.handleError)
        );
    }

    let finalReq = {
      "params": data,
      "method": method,
      "url": `${ApiBaseUrlBack}${endPoint}`
    }

    let type = "general-api";

    if (logginSessionKey != '') {
      finalReq["loginSessionKey"] = logginSessionKey;
    } else {
      type = "public-api";
    }

    switch (method) {
      case 'post':
      case 'put':
      case 'delete':
        this._httpOptions.body = JSON.stringify({ paramsObj: encrypt(JSON.stringify(finalReq)), type: type });
        break;
      // case 'get':
    }

    return this.http.request('post', `${ApiBaseUrl}`, this._httpOptions)
      .pipe(
        mergeMap(async (res: any) => {
          const result = await decrypt(res);
          this.loaderCustomService.hide();
          return result[endPoint];
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: Response | any) {
    let errMsg;
    if (error instanceof Response) {
      const body = error.json() || '';
      if (body !== '') {
        errMsg = body;
      } else {
        //const err = body.error || JSON.stringify(body);
        errMsg = new ServerMessage();
        errMsg.code = error.status;
        errMsg.message = error.statusText;
        //errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
      }
    } else {
      errMsg = new ServerMessage();
      errMsg.code = error.status ? error.status : 500;
      errMsg.message = error.message ? error.message : error.toString();
    }
    //console.error(errMsg);
    return throwError(errMsg);
  }

  jsonToBase64WithLetters(jsonObject: any): string {
    const base64String = btoa(JSON.stringify(jsonObject));
    return base64String;
  }

  base64WithLettersToJson(encodedString: string): any {
    const decodedString = atob(encodedString);
    return JSON.parse(decodedString);
  }

}